import { useCallback } from "react"

import type { ManualClView } from "@/domains/manual-cl-page/manual-cl-page-store"
import { Tabs, TabsList, TabsTrigger } from "@/domains/common/components/tabs"

export interface ManualClViewTabsProps {
  value: ManualClView
  onValueChange: (value: ManualClView) => void
  className?: string
}

const isValidValue = (v: string): v is ManualClView => {
  return ["all-pools", "my-positions"].includes(v)
}

export const ManualClViewTabs = ({ value, onValueChange, className }: ManualClViewTabsProps) => {
  const handleValueChange = useCallback(
    (value: string) => {
      if (!isValidValue(value)) {
        console.warn(`Invalid tab value: ${value}`)
        return "all-pools"
      }
      onValueChange(value as ManualClView)
    },
    [onValueChange],
  )

  return (
    <Tabs value={value} defaultValue="all-pools" onValueChange={handleValueChange}>
      <TabsList className={className}>
        <TabsTrigger value="all-pools">All Pools</TabsTrigger>
        <TabsTrigger value="my-positions">My Positions</TabsTrigger>
      </TabsList>
    </Tabs>
  )
}
